const clamp01 = (value) => Math.min(1, Math.max(0, Number(value) || 0));

export const PREVIEW_SUBTITLE_ANCHOR = { x: 0.5, y: 0.92 };

export const parseSubtitleAnchor = (position) => {
  const x = Number(position?.x);
  const y = Number(position?.y);
  if (!Number.isFinite(x) || !Number.isFinite(y)) {
    return null;
  }
  return {
    x: clamp01(x),
    y: clamp01(y),
  };
};

export const getPreviewSubtitleAnchor = (options) =>
  parseSubtitleAnchor(options?.position) || PREVIEW_SUBTITLE_ANCHOR;

export const clampSubtitleAnchor = ({ x, y }) => ({
  x: clamp01(x),
  y: clamp01(y),
});

export const clientPointToAnchor = ({ event, stage }) => {
  const rect = stage?.getBoundingClientRect?.();
  if (!rect?.width || !rect?.height) {
    return PREVIEW_SUBTITLE_ANCHOR;
  }

  return clampSubtitleAnchor({
    x: (event.clientX - rect.left) / rect.width,
    y: (event.clientY - rect.top) / rect.height,
  });
};

export const applySubtitleAnchorDom = (node, anchor) => {
  if (!node || !anchor) {
    return;
  }
  node.style.left = `${anchor.x * 100}%`;
  node.style.top = `${anchor.y * 100}%`;
};

export const clearSubtitleAnchorDom = (node) => {
  if (!node) {
    return;
  }
  node.style.left = "";
  node.style.top = "";
};
